/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FileManagementComponent } from 'src/app/files/file-management/file-management.component';
import { FileSelectedEvent } from 'src/app/files/file-view-context';
import { FileModel } from 'src/app/hickory-api';
import { CKEditorHelper } from '../rich-text-editor/ckeditor/ckeditor.helper';

declare const window: any;

@Component({
  selector: 'app-file-picker',
  templateUrl: './file-picker.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FileManagementComponent]

})
export class FilePickerComponent {

  public dialogRef = inject(MatDialogRef<FilePickerComponent>, { optional: true });

  submitImage(event: FileSelectedEvent) {
    if(event?.file && this.dialogRef) {
      this.dialogRef.close(event.file);
    } else if(event?.file && event.viewContext.functionNumber) {
      this.handleRteSubmit(event.file, event.viewContext.functionNumber);
    }
  }

  handleRteSubmit(file: FileModel, fn: number) {
    const fileName = file.FileName;
    const altText = file.Description || "";
    const fileUrl = file.PublicUrl
    window.opener.CKEDITOR.tools.callFunction(
      fn, file.PublicUrl,
      function () {
        const dialog = this.getDialog();
        if (dialog.getName() == 'link') {
          CKEditorHelper.trySetDialogInputValue(dialog, 'info', 'linkDisplayText', fileName);
        }

        if (dialog.getName() == 'image') {
          CKEditorHelper.trySetDialogInputValue(dialog, 'info', 'txtAlt', altText);
          CKEditorHelper.trySetDialogInputValue(dialog, 'info', 'txtUrl', fileUrl);
        }
      }
    );
    window.close();
  }

  onClose() {
    if (this.dialogRef) {
      this.dialogRef.close(null);
    } else {
      window.close();
    }
  }
}
